import React from "react"

const RIGHT_MARGIN_PX = 30

export function calcTocWidth(main_content_id, sidebar_container_id) {
  let elem = document.getElementById(main_content_id)
  let style = elem.currentStyle || window.getComputedStyle(elem)
  let left_margin = style.marginLeft

  let sidebar_container = document.getElementById(sidebar_container_id)

  sidebar_container.style.width =
    parseInt(left_margin.replace(/px/, "")) - RIGHT_MARGIN_PX + "px"
}

function parseItems(items) {
  return items.map(function(item) {
    return (
      <li>
        <a href={item.url}>{item.title}</a>
        <ul>{item.items != undefined ? parseItems(item.items) : ""}</ul>
      </li>
    )
  })
}

export function dirtyMdxTocParse(mdx_toc) {
  return (
    <ul id="table_root_list">
      {parseItems(mdx_toc.items)}
      <li>
        <a href={"#comments"}>Reader Comments</a>
      </li>
    </ul>
  )
}

function parseSelector(href) {
  // parse selector from href. for now, assumes the selector is
  // an ID, and that there is only one '#' in the href. Therefore,
  // we just return everything after the #.
  return href.split("#")[1]
}

export function initHeaderElems(toc_elems) {
  let header_elems = []
  for (let elem of toc_elems) {
    let selector = parseSelector(elem.href)
    let header_elem = document.getElementById(selector)
    header_elems.push(header_elem)
  }
  return header_elems
}

export function getSelectedIndex(header_elems) {
  let scrollPos = document.documentElement.scrollTop
  let currentIndex
  let found = false
  for (currentIndex in header_elems) {
    let elem = header_elems[currentIndex]
    if (elem.getBoundingClientRect().top > 10) {
      found = true
      break
    }
  }
  if (found) {
    currentIndex = Math.max(0, currentIndex - 1)
  } else {
    currentIndex = header_elems.length - 1
  }
  return currentIndex
}

export function selectIndex(toc_elems, index) {
  toc_elems[index].classList.add("selected")

  // DOM structure hardcoded, lots of DOM assumptions
  if (toc_elems[index].parentElement.parentElement.id == "table_root_list") {
    toc_elems[index].parentElement.classList.add("has_selected")
  } else {
    toc_elems[index].parentElement.parentElement.classList.add("has_selected")
  }
}

export function unselectAllToc(toc_elems) {
  for (let elem of toc_elems) {
    elem.classList.remove("selected")

    elem.parentElement.classList.remove("has_selected")
    elem.parentElement.parentElement.classList.remove("has_selected")
  }
}
